export const Routes = {
  DASHBOARD: "dashboard",
  LOGIN: "login",

  MEASUREMENT_UNIT_LIST: "measurementUnitList",
  MEASUREMENT_UNIT_DETAILS: "measurementUnitDetails",
  MEASUREMENT_UNIT_ADD: "measurementUnitAdd",

  USER_LIST: "userList",
  USER_ADD: "userAdd",
  USER_DETAILS: "userDetails",
  USER_DETAILS_ADMIN: "userDetailsAdmin",

  SERVICE_LIST: "serviceList",
  SERVICE_ADD: "serviceAdd",
  SERVICE_DETAILS: "serviceDetails",
  SERVICE_PRICE_LIST: "servicePriceList",
  SERVICE_PRICE_ADD: "servicePriceAdd",
  SERVICE_PRICE_DETAILS: "servicePriceDetails",
  PARTNER_LIST: "partnerList",
  PARTNER_ADD: "partnerAdd",
  PARTNER_DETAILS: "partnerDetails",

  BUSINESS_UNIT_LIST: "businessUnitList",
  BUSINESS_UNIT_ADD: "businessUnitAdd",
  BUSINESS_UNIT_DETAILS: "businessUnitDetails",

  WORK_ORDER_LIST: "workOrderList",
  WORK_ORDER_ADD: "workOrderAdd",
  WORK_ORDER_DETAILS_INTERNAL: "workOrderDetailsInternal",

  WORK_ORDER_DETAILS_PARTNER: "workOrderDetailsPartner",
  PRICE_LIST_OVERVIEW: "priceListOverview",
  PRICE_DETAILS_OVERVIEW: "priceDetailsOverview",
  CONTRACT_LIST: "contractList",
  CONTRACT_ADD: "contractAdd",
  CONTRACT_DETAILS: "contractDetails",

  SPECIFICATION_LIST: "specificationList",
  SPECIFICATION_ADD: "specificationAdd",
  SPECIFICATION_DETAILS: "specificationDetails",

  WORK_ORDER_TO_PDF: "workOrderToPDF",
  SPECIFICATION_TO_PDF: "specificationToPDF",

  LOG_LIST: "logList",
  LOG_DETAILS: "logDetails",
};
